import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { errorMsg, homeUrl, success } from '../utils/common_utils';
import { MSG_ERROR_PROGRESS_UI } from '../common_components/common_ui_components';
import { NavbarTop } from '../common_components/navbar_top';
import { ConnectAndBook } from '../common_components/connect_and_book';


function AllCompanyRoadmaps() {
  const { companyCode } = useParams(); // expects route like /dsa/:companyCode? (companyCode optional)

  const [roadmaps, setRoadmaps] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showProgress, setShowProgress] = useState(false);
  const [companyName, setCompanyName]=useState(companyCode)

  // this query will be used to filter roadmaps list
  const[query, setQuery]=useState("")

  // Build the correct endpoint
  const endpoint = companyCode
    ? `${homeUrl()}roadmapsApi/company/${companyCode}`
    : `${homeUrl()}roadmapsApi/all`;

    /** returns true then we display question else we don't */
  function showRoadmap(query, roadmap){
    const qq = (query ?? "").trim().toLowerCase();
    if(!qq || qq.length==0) return true;
    const heading = ""+roadmap.text+". "+(roadmap?.description ?? "") +
    " "+ (roadmap?.url ?? "")
    return (heading.toLowerCase().includes(qq) || 
                ((roadmap?.companies ?? []).some(
                (c) =>
                    (c?.name ?? "").toLowerCase().includes(qq) ||
                    (c?.code ?? "").toLowerCase().includes(qq)
                ))
        );
  }

  useEffect(() => {
    async function fetchRoadmaps() {
      setShowProgress(true);
      try {
        const res = await fetch(endpoint);
        const data = await res.json();

        if (success(data.status)) {
          setRoadmaps(data.roadmaps ?? []);
          //setCompanyName(data.companyName)
         // setMessage('Interview sets loaded successfully.');
        } else {
          setError(data.message || 'Failed to load interview roadmaps.');
        }
      } catch (e) {
        console.log('Error fetching interview roadmaps', e);
        setError(errorMsg());
      } finally {
        setShowProgress(false);
      }
    }
    fetchRoadmaps();
    // Reload if company code changes
  }, []);

  return (
    <div className=" flex flex-col items-center justify-center   mx-auto">
        <NavbarTop />
        <div className='mt-20'></div>
        <h1 className='text-4xl text-center my-8'>
            Interview Preparation Roadmaps
           {companyName &&
           <div className='mt-4 text-teal-700 font-bold font-mono'>
            {companyName}</div>
           }
        </h1>
        <br /> 
      {/* error success message and progressbar row */}
      <MSG_ERROR_PROGRESS_UI
        message={message}
        error={error}
        showProgress={showProgress}
      />

      {
      <div className='flex flex-col items-center justify-center w-2/3'>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search by company e.g. amazon"
        aria-label="Search by heading or company"
        className="w-full rounded-xl border border-gray-300
         bg-white px-4 py-2 pr-16 text-sm shadow-sm placeholder:text-gray-400
          focus:border-indigo-500 "
      />
      </div>
    }
    <br />

      {/* -----------  roadmaps row started ---------------- */}
     <div className="mx-auto max-w-4xl space-y-12 px-4 py-10 mb-12">
      {roadmaps
      .filter((roadmap) => showRoadmap(query, roadmap))
      .map((item, i) => {
        const even = i % 2 === 0;          // alternate rows
        return (
          <article
            key={item.url}
            className={`flex flex-col items-center gap-8 md:flex-row ${
              even ? "" : "md:flex-row-reverse"
            }`}
          >
            {/* thumbnail */}
            <img
              src={item.thumbnailUrl}
              alt={item.text}
              className="w-full max-w-sm rounded-xl shadow-lg md:w-1/3"
            />

            {/* text */}
            <div className="md:w-2/3">
              <h2 className="text-xl font-semibold leading-snug">
                {item.text}
              </h2>

               {item.description &&
            <div className=" text-gray-700 text-sm p-4"
              dangerouslySetInnerHTML={{ __html: item.description }}>
            </div>
            }

              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block rounded-full px-5 py-2 
                [overflow-wrap:anywhere]
                 text-sm  text-gray-800 transition underline
                  hover:text-teal-700 hover:underline"
              >
                {item.url}
              </a>
               

            { false &&  <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block rounded-full bg-teal-600 px-5 py-2 text-sm font-medium text-white transition hover:bg-blue-700"
              >
                Read article →
              </a>}

              {false && item.companies?.length > 0 && (
                <p className="mt-2 text-xs text-gray-500">
                  {item.companies.join(", ")}
                </p>
              )}
              <br /> <br />
            </div>
            
          </article>
        );
      })}
    </div>

      {/* ------------- roadmaps row ended ------------------- */}
      
      {
        <ConnectAndBook />
      }
      { roadmaps && roadmaps.length>0 && 
          <div className='min-h-16  w-full bg-gray-500'>
            
          </div>
        }
    </div>
  );
}

function RoadmapsLinkHomePage(){ 
    return (
        <a className='flex flex-col m-4 px-8 py-4
         text-white bg-purple-600 text-xl font-semibold
         text-center font-mono  rounded-md z-0 shadow-lg
         cursor-pointer leading-10
         hover:text-white hover:bg-purple-700'
        
         href="/roadmaps" >
         <span className='text-2xl font-bold'>Interview Roadmaps  </span>
          (Google/Amazon etc)
         <button className='bg-white mt-4 text-gray-600
         rounded-full  hover:text-gray-800' 
         >
            View</button>
        </a>
    )
  //  bg-purple-600 hover:bg-purple-700
}

export {AllCompanyRoadmaps, RoadmapsLinkHomePage}